import React from 'react'

const About = () => {
  return (
    <div className="bg-white text-gray-900 min-h-screen px-6 md:px-12 py-24 space-y-32">
      {/* Intro Section */}
      <section className="max-w-5xl mx-auto text-center">
        <h2 className="text-4xl md:text-6xl font-extrabold mb-6">
          What is Loot<span className="text-purple-600">Layer</span>?
        </h2>
        <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto">
          Loot<span className="text-purple-600">Layer</span> is a boutique collectibles shop based in Windsor, Ontario, curating exclusive action figures,
          pop culture memorabilia, and hidden gems from across the multiverse. We’re more than just a shop — we’re a shrine for collectors, dreamers, and fans.
        </p>
      </section>

      {/* Image and Story */}
      <section className="flex flex-col md:flex-row items-center gap-12 max-w-6xl mx-auto">
        <div className="flex-1">
          <img
            src="https://alitools.io/en/showcase/image?url=https%3A%2F%2Fae01.alicdn.com%2Fkf%2FH34ad621d63f74c33bddbeddbd9884c69s.jpg"
            alt="Collectibles display"
            className="w-full h-full rounded-2xl shadow-lg object-cover"
          />
        </div>
        <div className="flex-1">
          <h3 className="text-3xl font-semibold mb-4 text-purple-600">Our Story</h3>
          <p className="text-gray-700 mb-6">
            Born from a lifelong obsession with pop culture artifacts, Loot<span className="text-purple-600">Layer</span> started as a weekend market stall
            in downtown Windsor. Over time, we evolved into a modern collectible boutique online without losing our roots.
          </p>
          <p className="text-gray-600">
            Whether it’s a rare Funko Pop, an imported Gundam model, or vintage action figures from the 80s, we go out of our way to curate items that bring joy and nostalgia.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="max-w-6xl mx-auto text-center space-y-6">
        <h3 className="text-3xl md:text-4xl font-bold text-purple-600">Our Mission</h3>
        <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto">
          We aim to build a place where collectors feel understood — where stories, nostalgia, and passion collide into tangible pieces of joy.
        </p>
        <p className="text-gray-600 max-w-2xl mx-auto">
          We don't just sell collectibles — we curate experiences that connect people to the characters, worlds, and memories they love.
        </p>
      </section>

      {/* Visual Layered Callout */}
      <section className="max-w-6xl mx-auto relative">
        <div className="relative overflow-hidden rounded-2xl shadow-xl">
          <img
            src="https://images.unsplash.com/photo-1620207418302-439b387441b0?auto=format&fit=crop&w=1600&q=80"
            alt="Shelf of rare toys"
            className="w-full h-[400px] object-cover opacity-90"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-white via-white/80 to-transparent p-10 flex flex-col justify-center">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">Made for Collectors</h3>
            <p className="text-gray-700 max-w-lg">
              Every item we list is handpicked, researched, and presented with love. Whether you're into anime, comics, fantasy, or sci-fi — you're one of us.
            </p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default About
